
import { defineComponent } from 'vue'

import ActiveUserMixin from '~/mixins/activeUserMixin'
import AutoOnboardMixin from '~/mixins/autoOnboardMixin'
import OwnerDetailMixin from '~/mixins/ownerDetailMixin'

export default defineComponent({
  name: 'SelectReposToOnboard',
  mixins: [ActiveUserMixin, AutoOnboardMixin, OwnerDetailMixin],
  data() {
    return {
      searchCandidate: '',
      onboardingRepos: false,
      selectAll: false,
      fetchingData: false,
      selectedRepos: [] as string[],
      limit: 50,
      currentPage: 1
    }
  },
  async fetch() {
    await this.refetchData()
  },
  watch: {
    activeOwner: {
      handler() {
        this.resetListConfig()
      }
    }
  },
  mounted() {
    this.resetListConfig()
    this.$socket.$on('vcs-installed-repos-updated', this.refetchData)
  },
  beforeDestroy() {
    this.$socket.$off('vcs-installed-repos-updated', this.refetchData)
  },
  methods: {
    /**
     * Refetch repos that can be auto-onboarded
     *
     * @returns {Promise<void>}
     */
    async refetchData(): Promise<void> {
      this.fetchingData = true
      await this.fetchAutoOnboardableRepoList({
        login: this.activeOwner,
        provider: this.activeProvider,
        currentPageNumber: this.currentPage,
        limit: this.limit,
        query: this.searchCandidate,
        refetch: true
      })
      this.fetchingData = false
    },
    resetListConfig() {
      this.currentPage = 1
      this.resetOnboardableReposList()
    },

    async loadMore() {
      this.currentPage = this.currentPage + 1
      await this.refetchData()
    },

    async search() {
      this.resetListConfig()
      await this.refetchData()
    },

    async triggerOnboarding() {
      if (this.selectedRepos.length === 0) {
        this.$toast.show('Please select at least one repository to onboard.')
        return
      }

      if (!this.selectedTemplate) {
        this.$emit('back')
      } else {
        this.onboardingRepos = true

        try {
          const res = await this.startOnboarding({
            shortcode: this.selectedTemplate.shortcode,
            repoIds: this.selectedRepos
          })

          if (res.ok) {
            await this.fetchOnboardingEventList({
              login: this.activeOwner,
              provider: this.activeProvider,
              refetch: true
            })
            this.$toast.success('Onboarding started successfully')
            this.$emit('onboardingTriggered')
          } else {
            throw new Error('Onboarding trigger failed with a non true ok response')
          }
        } catch (e) {
          this.$toast.danger(
            'Something went wrong while onboarding these repositories, contact support'
          )
          this.logErrorForUser(e as Error, 'Onboarding repositories using auto onboard', {
            shortcode: this.selectedTemplate.shortcode,
            repoIds: this.selectedRepos.join(', ')
          })
        } finally {
          this.onboardingRepos = false
        }
      }
    },

    clearAllRepos() {
      this.selectedRepos = []
      this.selectAll = false
    },

    selectAllRepositories(val: boolean) {
      if (val) {
        this.selectedRepos = [...new Set(this.onboardableRepositories.map((repo) => repo.id))]
      } else {
        const availableRepos = this.onboardableRepositories.map((repo) => repo.id)
        this.selectedRepos = [
          ...new Set(this.selectedRepos.filter((repoId) => !availableRepos.includes(repoId)))
        ]
      }
    }
  }
})
